import { Box, useTheme } from '@mui/material';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { API_DELETE, DBRequest, useConfig } from '../../api/api';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import useFetch from '../../api/useFetch';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState } from 'react';
import CardGrid from '../../components/cards/layout/CardGrid';
import SpeedDialMenu from '../../components/menu/SpeedDialMenu';
import InfoCard from '../../components/cards/InfoCard';
import MoneyCard from '../../components/cards/MoneyCard';
import { MultiContactCard } from '../../components/cards/MultiContactCard';
import AddressCard from '../../components/cards/AddressCard';
import ExoDialog from '../../components/exo/ExoDialog';
import NewCompany from '../../components/new/NewCompany';
import CardContainer from '../../components/cards/layout/CardContainer';
import SkeletonCard from '../../components/cards/SkeletonCard';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PictureNameCard from '../../components/cards/PictureNameCards/PictureNameCard';
import TableCard from '../../components/cards/TableCard';
import { NewCompanyLead } from '../../components/new/NewCompanyLead';
import Cookies from 'universal-cookie';
import CategoryIcon from '@mui/icons-material/Category';
import { useAiPageContext } from '../../components/ai-chat';

export const ShowCompany = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();
  const cookies = new Cookies();
  const userId = cookies.get('userId');

  const { apiData, setApiData } = useFetch(`companies/${id}`);

  useAiPageContext(
    apiData?.data && {
      type: 'company',
      id: apiData.data.id,
      label: apiData.data.name,
    },
  );

  // menu
  function handleDelete() {
    DBRequest({
      config,
      path: `companies/${apiData.data.id}`,
      method: API_DELETE(),
      onResponse: navigate(`/companies`),
    });
  }

  const actionsWithoutLead = [
    {
      icon: <ModeEditIcon />,
      name: t('Edit'),
      onClick: handleEdit,
    },
    {
      icon: <CategoryIcon />,
      name: t('Convert to lead'),
      onClick: () => setOpenNewLead(true),
    },
    { icon: <DeleteOutlineIcon />, name: t('Delete'), onClick: handleDelete },
  ];

  const actions = [
    {
      icon: <ModeEditIcon />,
      name: t('Edit'),
      onClick: handleEdit,
    },
    { icon: <DeleteOutlineIcon />, name: t('Delete'), onClick: handleDelete },
  ];

  //edit company
  const [open, setOpen] = useState(false);
  const [startData, setStartData] = useState(null);
  function handleEdit() {
    setStartData(apiData.data);
    setOpen(true);
  }

  function handleUpdate(data) {
    setApiData(data);
    //onUpdate(data.data);
  }

  const infos = [
    {
      label: t('Nr'),
      value: apiData?.data.nr,
    },
  ];

  // lead
  const [openNewLead, setOpenNewLead] = useState(false);
  function handleLead(res) {
    setApiData({
      ...apiData,
      data: { ...apiData.data, companyLead: res.data },
    });
  }

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <CardGrid>
        {!apiData ? (
          <CompanySkeleton />
        ) : (
          <>
            <SpeedDialMenu
              actions={
                apiData?.data?.companyLead ? actions : actionsWithoutLead
              }
            />
            <PictureNameCard
              data={apiData.data}
              span={1}
              pictureUrl={apiData.data.logo && apiData.data.logo.thumbnailUrl}
              name={apiData.data.name}
              type="company"
            />
            <InfoCard infos={infos} />
            <MoneyCard
              title={t('Sales')}
              amount={apiData.data.salesTotal}
              span={2}
            />
            <MultiContactCard
              label={t('Phonenumbers')}
              contactArray={apiData.data.telephoneNumbers}
              nameKey="phoneType"
              valueKey="phoneNumber"
              Icon={PhoneIcon}
              linkPrefix="tel:"
            />
            <MultiContactCard
              label={t('E-Mailaddresses')}
              span={2}
              contactArray={apiData.data.emails}
              nameKey="emailType"
              valueKey="emailAddress"
              Icon={EmailIcon}
              linkPrefix="mailto:"
            />
            <AddressCard address={apiData.data.address} />
            {apiData?.data.companyLead && (
              <CardContainer>
                <NavLink
                  to={`/leads/companies/${apiData?.data.companyLead?.id}`}
                  className="w-full h-full flex items-center justify-center"
                >
                  <Box>{t('To the lead')}</Box>
                </NavLink>
              </CardContainer>
            )}

            <TableCard span={5} id={id} type={'company'} />
          </>
        )}
        <ExoDialog open={open} limitWidth>
          <NewCompany
            fullWidth
            onClose={() => setOpen(false)}
            onUpdate={handleUpdate}
            startData={startData}
          />
        </ExoDialog>
        <ExoDialog
          open={openNewLead}
          limitWidth
          onClose={() => setOpenNewLead(false)}
        >
          <NewCompanyLead
            onCreate={handleLead}
            startData={{
              ...apiData?.data,
              id: undefined,
              responsibleUser: { id: userId },
              companyId: apiData?.data.id,
            }}
            onClose={() => setOpenNewLead(false)}
          />
        </ExoDialog>
      </CardGrid>
    </Box>
  );
};

const CompanySkeleton = () => {
  return (
    <>
      <SkeletonCard height={186} />
      <SkeletonCard height={186} span={2} />
      <SkeletonCard height={186} />
      <SkeletonCard height={104} />
    </>
  );
};
